import React from 'react';
import config from '../../../config';
import { findOptionsForSelectFilter } from '../../../util/search';
import css from './OtherInfoSection.module.css';
import FilesSection from '../FilesSection/FilesSection';
import classNames from 'classnames';

//1. see if the value is an array
//2. if it's array return a bullet points list
//3. if not array return the <span>

const List = ({ items, publicData }) => {

  return (
    <ul className={css.list}>
      {items.map((item, index) => {

        if (item?.isCategoryCol && Array.isArray(item.value)) {
          
          return (
            <li key={item.label}>
              <p className={classNames(css.label, css.labelCategory)}>Category:</p>
              <ul className={classNames(css.columnItem, css.columnItemTwoColums, css.columnItemTwoColumsWrap)}>
                {item.value.map(cat => {

                  const selectedSubcategories = item.subcategoryValue.filter(subCat => subCat.parentCategory === cat)
                  const configOptions = key => findOptionsForSelectFilter(key, config.custom.filters);

                  const categoryOptions = configOptions('category');
                  const categoryLabel = categoryOptions.filter(item => item.key === cat)?.[0]?.label;

                  return (
                    <li className={css.columnItemCategory} key={cat}>
                      <h3>{categoryLabel}</h3>
                      <ul>
                        {/* <h3>Subcaetgory</h3> */}
                        {selectedSubcategories.map(subCat => {
                          const configOptions = key => findOptionsForSelectFilter(key, config.custom.filters);
                          const subcategoryOptions = configOptions('subcategory');
                          const subcategoryOtherDescription = publicData?.[`${cat}OtherDescription`]
                          const subcategoryLabel = subcategoryOptions.filter(item => item.key === subCat.key)?.[0]?.label;

                          const description =
                            typeof subcategoryOtherDescription === 'string' ? (
                              <li key={`${cat}OtherDescription`}>{subcategoryOtherDescription}</li>
                            ) : (
                              subcategoryOtherDescription?.map(option => {
                                return <li key={option}>{option}</li>;
                              })
                            );

                          if (subCat.key === 'otherOther') {
                            
                            return (
                              <li key={subCat.key} >
                                {subCat?.key?.includes('Other') && description}
                              </li>
                            );
                          } 
                          
                          else {

                            return (
                              <li key={subCat.key}>
                                {subcategoryLabel}
                                <ul className={css.otherDescription}>
                                  {subCat?.key?.includes('Other') && description}
                                </ul>
                              </li>
                            );
                          }
                        })}
                      </ul>
                    </li>
                  )
                })}
              </ul>
            </li>
          )
        }

        else if (item?.withPrice) {
          const configOptions = key => findOptionsForSelectFilter(key, config.custom.filters);
          const subcategoryOptions = configOptions('subcategory');
          const selectedLabelsArr = item.value.map(item => item.key)
          const selectedPriceArr = item.value.map(item => item)
          const isPriceSelected = selectedPriceArr.filter(item => !!item.min && !!item.max)
          const labelArr = subcategoryOptions.filter(item => selectedLabelsArr.includes(item.key))
          return (
            <li className={classNames(css.columnItem, css.columnItemTwoColums)}>
              <div>
                <span className={css.label}>{item.label}:</span>
                <ul className={css.valuesList}>
                  {labelArr.map(value => {
                    return (
                      <li key={value.label}>
                        <span>{value.label}</span>
                      </li>
                    )
                  })}
                </ul>
              </div>
              {/* <div>
                <span className={css.label}>{!!isPriceSelected?.length && 'Price range:'}</span>
                <ul className={css.valuesList}>
                  {labelArr.map(item => {

                    const minPrice = !!selectedPriceArr?.length
                      && selectedPriceArr?.filter(price => item.key === price.key)?.[0]?.min

                    const maxPrice = !!selectedPriceArr?.length &&
                      selectedPriceArr?.filter(price => item.key === price.key)?.[0]?.max

                    if (minPrice || maxPrice) {
                      return (
                        <li>
                          <span>£{minPrice}{minPrice && maxPrice && ' - '}{maxPrice}</span>
                        </li>
                      )
                    } else {
                      return (
                        <li className={css.valuesListEmptyItem}>
                          <span></span>
                        </li>
                      )
                    }
                  })}
                </ul>
              </div> */}
            </li>
          )
        }

        const { label, value } = item || {};
        if (!label || !value || !value?.[0]) {
          return null;
        }
        if (item.type === 'files' && item.value) {
          return (
            <li key={index?.toString()} className={classNames(css.item, css.itemFiles)}>
              <FilesSection
                files={item.value}
                label={item.label}
                value={item.labelValue}
                labelClassName={css.label}
                showAsSwiper
              />
            </li>
          );
        }

        const valueIsArray = Array.isArray(value);
        let itemValue = null;

        if (valueIsArray) {
          itemValue = (
            <ul 
            className={classNames(
              css.valuesList,
              {[css.valuesList3Col]: value?.length > 10},
            )}
            >
              {value.map((v, index) => (
                <li key={index?.toString()}>{v}</li>
              ))}
            </ul>
          );
        } else {
          itemValue = <span className={css.value}>{value}</span>;
        }
        return (
          <li key={index?.toString()} className={valueIsArray ? css.columnItem : css.item}>
            <span className={css.label}>{label}:</span>
            {itemValue}
          </li>
        );
      })}
    </ul>
  );
};

const OtherInfoSection = ({ listing, publicData, intl, isProviderListing, subscriptionLevelToLow, isOwnListing }) => {

  if (!publicData) {
    return null;
  }

  const configOptions = key => findOptionsForSelectFilter(key, config.custom.filters);

  //provider info
  const address = publicData.address && {
    label: 'Location',
    value: publicData.address,
  };

  const options = configOptions('category');
  const categoryLabel = !!publicData.category?.[0] ? publicData?.category : options.find(o => o.key === publicData.category)?.label;
  const category = publicData.category && {
    label: 'Category',
    value: categoryLabel,
    subcategoryValue: publicData?.subcategoryPriceValues || [],
    isCategoryCol: !!publicData.category?.[0]
  };

  const companySizeOptions = configOptions('companySize');
  const companySizeLabel = !!publicData.companySize?.length && companySizeOptions.filter(o => publicData?.companySize?.includes(o.key))
  const companySizeLabelArr = !!companySizeLabel && companySizeLabel.map(item => item.label)
  const companySize = Array.isArray(publicData.companySize) &&
    publicData.companySize && {
    label: 'Company size',
    value: companySizeLabelArr[0],
  };

  const operatingSinceOptions = configOptions('operatingSince');
  const operatingSinceLabel = !!publicData.operatingSince?.length && operatingSinceOptions.filter(o => publicData?.operatingSince?.includes(o.key))
  const operatingSinceLabelArr = !!operatingSinceLabel && operatingSinceLabel.map(item => item.label)
  const operatingSince = Array.isArray(publicData.operatingSince) &&
    publicData.operatingSince && {
    label: 'Years working in blockchain',
    value: operatingSinceLabelArr[0],
  };

  const differentiationFromCompetitors = (!subscriptionLevelToLow || isOwnListing) && publicData.differentiationFromCompetitors && {
    label: 'Differentiation from competitors',
    value: publicData.differentiationFromCompetitors,
  };

  const associations = (!subscriptionLevelToLow || isOwnListing) && publicData.associations && {
    label: 'Association',
    labelValue: publicData?.associationTitle || null,
    value: publicData.associations,
    type: 'files',
  };

  const qualifications = (!subscriptionLevelToLow || isOwnListing) && publicData.qualifications && {
    label: 'Qualification',
    labelValue: publicData?.qualificationTitle || null,
    value: publicData.qualifications,
    type: 'files',
  };

  const supportedCountries = config.stripe.supportedCountries
  const isAllSelected = supportedCountries?.length === publicData?.geographicalFocus?.length

  const geographicalFocus = publicData.geographicalFocus && {
    label: 'Geographical focus',
    value: isAllSelected ? intl.formatMessage({ id: `PayoutDetailsForm.countryNames.All` }) :
      publicData.geographicalFocus.map(c => {
        return intl.formatMessage({ id: `PayoutDetailsForm.countryNames.${c}` });
      }),
  };

  const paymentMethod = publicData.paymentMethod && {
    label: 'Payment method',
    value: publicData.paymentMethod.map(c => {
      const options = configOptions('paymentMethod');
      return options.find(o => o.key === c)?.label;
    }),
  };

  const questions = publicData.xxxxxxxxx && {
    label: 'Questions',
    value: publicData.questions,
  };

  const shortDescription = publicData.shortDescription && {
    label: 'Business tag line',
    value: publicData.shortDescription,
  };

  const subcategoryOptions = configOptions('subcategory');
  const subCategoryLabel = !!publicData.subcategory?.length && subcategoryOptions.filter(o => publicData.subcategory.includes(o.key))
  const subCategoryLabelArr = !!subCategoryLabel && subCategoryLabel.map(item => item.label)
  const subcategoryPriceValues = publicData?.subcategoryPriceValues;

  const subcategory = publicData.subcategory && !Array.isArray(publicData.category) && {
    label: 'Subcategory',
    value: subcategoryPriceValues || subCategoryLabelArr || publicData?.subcategory,
    withPrice: true,
  };

  const legalOtherDescription = publicData?.legalOtherDescription;
  const marketingOtherDescription = publicData?.marketingOtherDescription;
  const insuranceOtherDescription = publicData?.insuranceOtherDescription;
  const accountingOtherDescription = publicData?.accountingOtherDescription;
  const consultingOtherDescription = publicData?.consultingOtherDescription;

  const isOtherSubcategoryDescription =
    legalOtherDescription ||
    marketingOtherDescription ||
    insuranceOtherDescription ||
    accountingOtherDescription ||
    consultingOtherDescription;

  const otherSubcategoryDescription = {
    legalOtherDescription,
    marketingOtherDescription,
    insuranceOtherDescription,
    accountingOtherDescription,
    consultingOtherDescription,
  };

  const whatYouDo = publicData.whatYouDo && {
    label: 'What I do',
    value: publicData.whatYouDo,
  };

  //client info
  const whatAreYouLookingFor = publicData.whatAreYouLookingFor && {
    label: 'What I am looking for',
    value: publicData.whatAreYouLookingFor,
  };

  const providerItems = [
    address,
    category,
    subcategory,
    companySize,
    operatingSince,
    differentiationFromCompetitors,
    associations,
    qualifications,
    geographicalFocus,
    paymentMethod,
    questions,
    legalOtherDescription,
    marketingOtherDescription,
    insuranceOtherDescription,
    accountingOtherDescription,
    consultingOtherDescription
    // shortDescription,
    // whatYouDo,
  ];


  const clientItems = [address, questions, companySize, operatingSince];

  return (
    <div className={css.wrapper}>
      <h2 className={css.descriptionTitle}>Other info</h2>
      <List items={isProviderListing ? providerItems : clientItems} publicData={publicData} />
    </div>
  );
};

export default OtherInfoSection;

// write a react functional component, that uses css modules imported as "css" and receives through props and array of jsons. Each json from the array has 2 keys: "label" and "value". The react component should return a list based on the array of jsons. The list will use the "label" as label, "value" as the value for the label, if the value is an array, there will be a coma separated list.
